import {
  GetLessonMaterials,
  GetLessonMaterialsVariables,
} from 'approot/shared/lesson-materials/__generated__/GetLessonMaterials';
import { GET_LESSON_MATERIALS } from 'approot/shared/lesson-materials/lesson-materials.graphql';
import { useLoggingQuery } from 'lib/apollo/apollo-hooks';

export const useGetActivityMaterials = ({
  lessonId,
  skip,
  authenticate = false,
}: {
  lessonId?: number;
  skip?: boolean;
  authenticate?: boolean;
}) => {
  const { data, loading } = useLoggingQuery<
    GetLessonMaterials,
    GetLessonMaterialsVariables
  >(
    GET_LESSON_MATERIALS,
    {
      variables: {
        input: {
          id: lessonId!,
        },
      },
      skip: !lessonId || skip,
      fetchPolicy: 'cache-and-network',
    },
    authenticate
  );

  return {
    activitiesMaterials: data?.getLessonMaterials,
    loading,
  };
};
